module.exports = __webpack_public_path__ + "static/media/Plays.2d495028.PNG";